<template>
    <div class="c-join">
        <div class="head-box"><navBar :isNav2="true"></navBar></div>
        <div class="content">
            <!-- banner -->
            <div class="banner-box" :style="'background-image: url(' + require('../../assets/images/join-banner.jpg') + ')'">
                <div class="container1" @click.stop>
                    <div class="text-content wow fadeInUp">
                        <p class="name pingFang-Bold font50">加入数位 共创未来</p>
                        <router-link :to="{ name: 'job' }" class="but but-blank but-blank-hover understand-details" type="primary" round>
                            查看在招职位&nbsp;
                            <span class="arrow el-icon-d-arrow-right"></span>
                        </router-link>
                    </div>
                </div>
            </div>
            <!-- 加入我们内容1 -->
            <div class="c-join1">
                <div class="container1">
                    <ul class="c-list">
                        <li class="wow fadeInUp">
                            <router-link :to="{ name: 'job' }" class="c-wrap">
                                <div class="public-img">
                                    <img src="../../assets/images/join1-1.jpg" alt="" />
                                </div>
                                <div class="c-text-box">
                                    <h3 class="c-title font22 pingFang-Bold">社会招聘</h3>
                                    <div to="" class="but but-blank understand-details" type="primary" round>
                                        查看更多&nbsp;
                                        <span class="el-icon-arrow-right"></span>
                                    </div>
                                </div>
                            </router-link>
                        </li>
                        <li class="wow fadeInUp">
                            <router-link :to="{ name: 'job' }" class="c-wrap">
                                <div class="public-img">
                                    <img src="../../assets/images/join1-2.jpg" alt="" />
                                </div>
                                <div class="c-text-box">
                                    <h3 class="c-title font22 pingFang-Bold">校园招聘</h3>
                                    <div class="but but-blank understand-details" type="primary" round>
                                        查看更多&nbsp;
                                        <span class="el-icon-arrow-right"></span>
                                    </div>
                                </div>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 加入我们内容2 -->
            <div class="c-join2">
                <div class="container1">
                    <div class="c-title-box">
                        <h2 class="c-title font40 pingFang-Bold wow fadeInUp">数位人才观</h2>
                    </div>
                    <div class="c-banner-wrap wow fadeInUp">
                        <div class="c-prev"><span class="el-icon-arrow-left"></span></div>
                        <div class="c-next"><span class="el-icon-arrow-right"></span></div>
                        <div class="swiper-container banner-swiper" id="mySwiper">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide" v-for="(item, index) in bannerList" :key="index">
                                    <div class="c-item" v-for="(item2, index2) in item" :key="index2">
                                        <div class="c-box">
                                            <img :src="item2.src" :alt="item2.title" />
                                            <div class="c-text-box">
                                                <h3 class="c-title pingFang-Bold font26">{{ item2.title }}</h3>
                                                <p class="c-text">{{ item2.text }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 加入我们内容3 -->
            <div class="c-join3">
                <div class="container1">
                    <div class="c-title-box">
                        <h2 class="c-title font40 pingFang-Bold wow fadeInUp">福利体系</h2>
                    </div>
                    <ul class="c-list">
                        <li class="wow fadeInUp">
                            <div class="c-wrap">
                                <div class="public-img">
                                    <img src="../../assets/images/join3-1.svg" alt="" />
                                    <img src="../../assets/images/join3-1-h.svg" alt="" />
                                </div>
                                <h3 class="c-title font22">薪酬奖金</h3>
                                <p class="c-text">具有行业竞争力的薪资、绩效奖金、丰厚年终奖金，年度调薪</p>
                            </div>
                        </li>
                        <li class="wow fadeInUp">
                            <div class="c-wrap">
                                <div class="public-img">
                                    <img src="../../assets/images/join3-2.svg" alt="" />
                                    <img src="../../assets/images/join3-2-h.svg" alt="" />
                                </div>
                                <h3 class="c-title font22">期权激励</h3>
                                <p class="c-text">有机会成为企业合伙人，共同奋斗，共创未来</p>
                            </div>
                        </li>
                        <li class="wow fadeInUp">
                            <div class="c-wrap">
                                <div class="public-img">
                                    <img src="../../assets/images/join3-3.svg" alt="" />
                                    <img src="../../assets/images/join3-3-h.svg" alt="" />
                                </div>
                                <h3 class="c-title font22">五险一金</h3>
                                <p class="c-text">社保（一档综合医疗）+全额住房公积金，健康体检</p>
                            </div>
                        </li>
                        <li class="wow fadeInUp">
                            <div class="c-wrap">
                                <div class="public-img">
                                    <img src="../../assets/images/join3-4.svg" alt="" />
                                    <img src="../../assets/images/join3-4-h.svg" alt="" />
                                </div>
                                <h3 class="c-title font22">带薪休假</h3>
                                <p class="c-text">各类职业培训，快速提升行业视野与个人能力，年度晋升晋级</p>
                            </div>
                        </li>
                        <li class="wow fadeInUp">
                            <div class="c-wrap">
                                <div class="public-img">
                                    <img src="../../assets/images/join3-5.png" alt="" />
                                    <img src="../../assets/images/join3-5-h.png" alt="" />
                                </div>
                                <h3 class="c-title font22">团队建设</h3>
                                <p class="c-text">各种团建，节日活动，节日礼物，年终尾牙</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 加入我们内容4 -->
            <div class="c-join4">
                <div class="container1">
                    <div class="c-title-box">
                        <h2 class="c-title font40 pingFang-Bold wow fadeInUp">热招职位</h2>
                    </div>
                    <ul class="c-list">
                        <li>
                            <router-link :to="{ name: 'job' }" class="c-wrap  wow fadeInUp">
                                <div class="public-img">
                                    <img src="../../assets/images/join4-1.svg" alt="" />
                                    <img src="../../assets/images/join4-1-h.svg" alt="" />
                                </div>
                                <div class="c-text-box">
                                    <h3 class="c-title font24">研发类</h3>
                                    <p class="c-text">JAVA开发工程师，python工程师，软件测试工程师…</p>
                                </div>
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{ name: 'job' }" class="c-wrap  wow fadeInUp">
                                <div class="public-img">
                                    <img src="../../assets/images/join4-2.svg" alt="" />
                                    <img src="../../assets/images/join4-2-h.svg" alt="" />
                                </div>
                                <div class="c-text-box">
                                    <h3 class="c-title font24">产品类</h3>
                                    <p class="c-text">产品经理，平台产品经理，产品运营…</p>
                                </div>
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{ name: 'job' }" class="c-wrap  wow fadeInUp">
                                <div class="public-img">
                                    <img src="../../assets/images/join4-3.svg" alt="" />
                                    <img src="../../assets/images/join4-3-h.svg" alt="" />
                                </div>
                                <div class="c-text-box">
                                    <h3 class="c-title font24">营销类</h3>
                                    <p class="c-text">渠道总监，大客户经理，电话销售，增值经理/专员，商务…</p>
                                </div>
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{ name: 'job' }" class="c-wrap  wow fadeInUp">
                                <div class="public-img">
                                    <img src="../../assets/images/join4-4.svg" alt="" />
                                    <img src="../../assets/images/join4-4-h.svg" alt="" />
                                </div>
                                <div class="c-text-box">
                                    <h3 class="c-title font24">设计类</h3>
                                    <p class="c-text">UI设计师，平面设计师…</p>
                                </div>
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{ name: 'job' }" class="c-wrap  wow fadeInUp">
                                <div class="public-img">
                                    <img src="../../assets/images/join4-5.svg" alt="" />
                                    <img src="../../assets/images/join4-5-h.svg" alt="" />
                                </div>
                                <div class="c-text-box">
                                    <h3 class="c-title font24">职能类</h3>
                                    <p class="c-text">HRBP，会计，行政专员…</p>
                                </div>
                            </router-link>
                        </li>
                    </ul>
                    <router-link :to="{ name: 'job' }" class="c-btn font18 wow fadeInUp">
                        <span>立即投递</span>
                        <img src="../../assets/images/arrow.svg" alt="" />
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from 'swiper'; //  ES6 导入swiper js文件
import 'swiper/dist/css/swiper.min.css'; // ES6 导入swiper css文件
import navBar from '../../components/navBar.vue';
import { initWow } from '@/utils/wow';
export default {
    name: 'joinUs',
    data() {
        return {
            bannerList: [
                [
                    {
                        src: require('../../assets/images/join2-1.jpg'),
                        title: '聪明',
                        text: '专业的能力和开放的思维，智商和情商都高'
                    },
                    {
                        src: require('../../assets/images/join2-2.jpg'),
                        title: '乐观',
                        text: '专业的能力和开放的思维，智商和情商都高'
                    },
                    {
                        src: require('../../assets/images/join2-3.jpg'),
                        title: '皮实',
                        text: '经得起折腾、棒杀和捧杀都没关系，能抗压不骄傲'
                    },
                    {
                        src: require('../../assets/images/join2-4.jpg'),
                        title: '自省',
                        text: '经常反省自身，不自大不骄傲'
                    }
                ],
                [
                    {
                        src: require('../../assets/images/join2-1.jpg'),
                        title: '聪明',
                        text: '专业的能力和开放的思维，智商和情商都高'
                    },
                    {
                        src: require('../../assets/images/join2-2.jpg'),
                        title: '乐观',
                        text: '专业的能力和开放的思维，智商和情商都高'
                    },
                    {
                        src: require('../../assets/images/join2-3.jpg'),
                        title: '皮实',
                        text: '经得起折腾、棒杀和捧杀都没关系，能抗压不骄傲'
                    },
                    {
                        src: require('../../assets/images/join2-4.jpg'),
                        title: '自省',
                        text: '经常反省自身，不自大不骄傲'
                    }
                ],
                [
                    {
                        src: require('../../assets/images/join2-1.jpg'),
                        title: '聪明',
                        text: '专业的能力和开放的思维，智商和情商都高'
                    },
                    {
                        src: require('../../assets/images/join2-2.jpg'),
                        title: '乐观',
                        text: '专业的能力和开放的思维，智商和情商都高'
                    },
                    {
                        src: require('../../assets/images/join2-3.jpg'),
                        title: '皮实',
                        text: '经得起折腾、棒杀和捧杀都没关系，能抗压不骄傲'
                    },
                    {
                        src: require('../../assets/images/join2-4.jpg'),
                        title: '自省',
                        text: '经常反省自身，不自大不骄傲'
                    }
                ]
            ]
        };
    },
    created() {},
    mounted() {
        new Swiper('.banner-swiper', {
            slidesPerView: 1, // 同时展示几屏
            spaceBetween: 30, // 两屏之间的间隔
            loop: true, // 循环轮播
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            },
            navigation: {
                nextEl: '.c-join2 .c-next',
                prevEl: '.c-join2 .c-prev'
            }
        });
        this.$nextTick(() => {
            initWow();
        });
    },
    computed: {},
    methods: {},
    components: { navBar },
    beforeDestroy() {},
    watch: {}
};
</script>

<style scoped lang="less">
::v-deep .navBar-box {
    z-index: 100;
    background: #fff;
    .navbar .nav-link {
        color: #333333;
    }
    .navbar .right-box .el-dropdown-link,
    .navbar {
        color: #333;
    }
    .navbar .nav-link .arrow {
        background-image: url(../../assets/images/arrow-down2.svg);
    }
    .navbar .navbar-toggler .icon-caidan {
        color: #333;
    }
    .navbar .navbar-collapse {
        @media @max-sm {
            position: absolute;
            top: 80px;
            left: 0;
            width: 100%;
            padding: 0 20px;
            background: #fff;
            overflow: hidden;
        }
    }
    .left-box {
        @media @max-sm {
            display: flex;
            align-items: center;
            height: 60px;
        }
    }
}
.c-join {
    .head-box {
        width: 100%;
        height: 80px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 90;
        background-color: #ffffff;
    }
    // banner
    .banner-box {
        width: 100%;
        height: 600px;
        box-sizing: border-box;
        padding: 80px 0 0 0;
        background-repeat: no-repeat;
        background-size: cover;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        @media @max-xs {
            height: 100vw;
        }
        .text-content {
            text-align: center;
            color: #fff;
            .but {
                margin-top: 50px;
                display: inline-block;
                color: #fff;
                background-color: #eb5405;
                padding: 16px 40px;
                font-size: 16px;
                border: none;
                border-radius: 35px;
                transition: all 0.3s;
                @media @max-xs {
                    margin-top: 20px;
                    padding: 10px 15px;
                }
            }
            .but-blank {
                border: thin solid #eb5405;
            }
        }
    }
    // 加入我们内容1
    .c-join1 {
        padding: 140px 0 120px;
        @media @max-xs {
            padding: 60px 0;
        }
        .c-list {
            display: flex;
            flex-wrap: wrap;
            margin: 0 -20px -40px;
            @media @max-xs {
                margin: 0 0 -40px;
            }
            li {
                width: 50%;
                padding: 0 20px 40px;
                @media @max-xs {
                    padding: 0 0 40px;
                    width: 100%;
                }
                .c-wrap {
                    .public-img {
                        border-radius: 10px;
                        &::before {
                            padding-top: 66.568%;
                        }
                    }
                    .c-text-box {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        position: relative;
                        z-index: 2;
                        margin: -50px 40px 0;
                        padding: 30px;
                        height: 100px;
                        background: #fff;
                        border-radius: 5px;
                        box-shadow: 0 4px 40px rgba(50, 50, 51, 0.06);
                        color: #333;
                        @media @max-sm {
                            margin: -50px 20px 0;
                        }
                        .c-title {
                            margin-bottom: 0;
                            line-height: 1.5;
                        }
                        .but {
                            display: flex;
                            align-items: center;
                        }
                        ::v-deep {
                            .el-icon-arrow-right {
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                width: 45px;
                                height: 45px;
                                border: 1px solid #ddd;
                                border-radius: 50%;
                                color: #ddd;
                                margin-left: 10px;
                                transition: all 0.3s;
                            }
                        }
                    }
                    &:hover {
                        .public-img {
                            img {
                                transform: scale(1.05);
                            }
                        }
                        .c-text-box {
                            ::v-deep {
                                .el-icon-arrow-right {
                                    border-color: #eb5405;
                                    background: #eb5405;
                                    color: #fff;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    // 加入我们内容2
    .c-join2 {
        padding: 120px 0;
        background: #fafafa;
        @media @max-xs {
            padding: 60px 0;
        }
        .c-title-box {
            .c-title {
                margin-bottom: 40px;
                text-align: center;
                @media @max-xs {
                    margin-bottom: 30px;
                }
            }
        }
        .c-banner-wrap {
            position: relative;
            .c-prev,
            .c-next {
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: 50%;
                z-index: 10;
                width: 54px;
                height: 54px;
                border-radius: 50%;
                border: 1px solid #cdcdcd;
                transform: translateY(-50%);
                transition: all 0.3s;
                cursor: pointer;
                color: #cdcdcd;
                @media @max-md {
                    display: none;
                }
                &:hover {
                    color: #fff;
                    background: #eb5405;
                    border-color: #eb5405;
                }
            }
            .c-prev {
                left: -100px;
            }
            .c-next {
                right: -100px;
            }
            .swiper-slide {
                overflow: hidden;
                .c-item {
                    float: left;
                    width: 50%;
                    height: 482px;
                    padding: 0 7px 14px;
                    @media @max-xs {
                        width: 100% !important;
                        height: 60vw !important;
                    }
                    &:nth-child(2),
                    &:nth-child(3) {
                        width: 25.1%;
                        height: 241px;
                        @media @max-sm {
                            width: 50%;
                        }
                    }
                    &:nth-child(4) {
                        width: 24.9%;
                        margin-top: -240px;
                        @media @max-sm {
                            margin: 0;
                            width: 100%;
                        }
                    }
                    .c-box {
                        position: relative;
                        height: 100%;
                        overflow: hidden;
                        border-radius: 10px;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                            transition: all 0.5s;
                        }
                        .c-text-box {
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            width: 100%;
                            padding: 20px 30px;
                            color: #fff;
                            .c-title {
                                margin-bottom: 5px;
                            }
                            .c-text {
                                min-height: 3em;
                                @media @max-xs {
                                    min-height: auto;
                                }
                            }
                        }
                        &:hover {
                            img {
                                transform: scale(1.05);
                            }
                        }
                    }
                }
            }
        }
    }
    // 加入我们内容3
    .c-join3 {
        padding: 120px 0;
        text-align: center;
        @media @max-xs {
            padding: 60px 0;
        }
        .c-title-box {
            .c-title {
                margin-bottom: 50px;
            }
        }
        .c-list {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin: 0 -70px;
            @media @max-sm {
                margin: 0;
            }
            li {
                position: relative;
                z-index: 1;
                width: 20%;
                border-radius: 50%;
                // border: 1px solid #e7e7e7;
                transition: all 0.3s;
                margin-left: -30px;
                background: #fff;
                @media @max-md {
                    width: 33.333%;
                }
                @media @max-sm {
                    margin: 0 3% 20px 0;
                    width: 46%;
                }
                @media @max-xs {
                    margin: 0 0 20px 0;
                    width: 100%;
                }
                &:nth-child(1) {
                    margin-left: 0;
                }
                &::before {
                    content: '';
                    display: block;
                    padding-top: 100%;
                }
                &::after {
                    content: '';
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    border: 1px solid #e7e7e7;
                    transition: all 0.5s;
                    border-radius: 1000px;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
                .c-wrap {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    padding: 50px;
                    width: 100%;
                    @media @max-xs {
                        padding: 40px;
                    }
                    .public-img {
                        display: inline-block;
                        width: 45px;
                        height: 45px;
                        img {
                            object-fit: contain;
                            &:nth-child(2) {
                                opacity: 0;
                                // transition: all .3s;
                                transition: unset;
                            }
                        }
                    }
                    .c-title {
                        margin: 20px 0;
                    }
                    .c-text {
                        font-size: 14px;
                    }
                }
                &:hover {
                    z-index: 2;
                    // border-color: #eb5405;
                    .c-wrap {
                        .public-img {
                            img:nth-child(2) {
                                opacity: 1;
                            }
                        }
                    }
                    &::after {
                        border-color: #eb5405;
                    }
                }
            }
        }
    }
    // 加入我们内容4
    .c-join4 {
        padding: 120px 0;
        background: #fafafa;
        @media @max-xs {
            padding: 60px 0;
        }
        .c-title-box {
            .c-title {
                margin-bottom: 30px;
                @media @max-md {
                    text-align: center;
                }
            }
        }
        .c-list {
            display: flex;
            flex-wrap: wrap;
            margin: 0 -20px 30px;
            @media @max-md {
                justify-content: center;
            }
            @media @max-xs {
                margin: 0 0 20px;
            }
            li {
                display: flex;
                width: 33.3333%;
                padding: 0 20px 40px;
                @media @max-sm {
                    width: 50%;
                }
                @media @max-xs {
                    padding: 0 0 20px;
                    width: 100%;
                }
                .c-wrap {
                    width: 100%;
                    color: #333;
                    background: #fff;
                    border-radius: 5px;
                    box-shadow: 0 2px 21px rgba(22, 36, 72, 0.06);
                    display: flex;
                    align-items: center;
                    padding: 30px;
                    transition: all 0.3s;
                    @media @max-md {
                        flex-wrap: wrap;
                        text-align: center;
                    }
                    .public-img {
                        flex-shrink: 0;
                        width: 120px;
                        height: 120px;
                        background: #f6f6f6;
                        // transition: all .3s;
                        border-radius: 50%;
                        transition: unset;
                        @media @max-lg {
                            margin: 0 auto;
                            width: 100px;
                            height: 100px;
                        }
                        img {
                            top: 50%;
                            left: 50%;
                            width: 56px;
                            height: 56px;
                            transform: translate(-50%, -50%);
                            &:nth-child(2) {
                                opacity: 0;
                                // transition: all .3s;
                                transition: unset;
                            }
                        }
                    }
                    .c-text-box {
                        padding-left: 30px;
                        width: 100%;
                        @media @max-md {
                            padding: 20px 0;
                            width: 100%;
                        }
                        .c-title {
                            margin-bottom: 10px;
                        }
                        .c-text {
                            color: #666666;
                            @media @max-lg {
                                font-size: 14px;
                            }
                        }
                    }
                    &:hover {
                        background: #eb5405;
                        color: #fff;
                        .public-img {
                            background: #f27041;
                            img:nth-child(2) {
                                opacity: 1;
                            }
                        }
                        .c-text-box .c-text {
                            color: #fff;
                            transition: all 0.3s;
                        }
                    }
                }
            }
        }
        .c-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
            width: 100%;
            max-width: 370px;
            height: 66px;
            border-radius: 4px;
            color: #fff;
            background: #eb5405;
            @media @max-xs {
                height: 46px;
            }
            img {
                margin-left: 10px;
                width: 14px;
            }
        }
    }
}
</style>
